import { env } from "next-runtime-env";

export const NODE_ENV = process.env.NODE_ENV || "production";

// graphql
export const NEXT_PUBLIC_GRAPHQL_GATEWAY_URL =
  env("NEXT_PUBLIC_GRAPHQL_GATEWAY_URL") ||
  "https://supergraph-edge.grover.com/graphql";
export const NEXT_PUBLIC_POS_SERVICE_URL =
  env("NEXT_PUBLIC_POS_SERVICE_URL") || "https://pos.eu-staging.grover.com";

// Analytics
export const NEXT_PUBLIC_SEGMENT_ANALYTIC_KEY =
  env("NEXT_PUBLIC_SEGMENT_ANALYTIC_KEY") || "unknown";

// Datadog
export const DD_VERSION = env("NEXT_PUBLIC_DD_VERSION") || "unknown";
export const DD_ENV = env("NEXT_PUBLIC_DD_ENV") || "unknown";
export const DD_APPLICATION_ID = env("NEXT_PUBLIC_DD_APPLICATION_ID") || "";
export const DD_CLIENT_TOKEN = env("NEXT_PUBLIC_DD_CLIENT_TOKEN") || "";
export const DD_SITE = env("NEXT_PUBLIC_DD_SITE") || "datadoghq.eu";
export const DD_SERVICE_NAME = env("NEXT_PUBLIC_DD_SERVICE_NAME") || "pos-ui";
export const DD_SESSION_SAMPLE_RATE =
  Number(env("NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE")) || 100;
export const DD_SESSION_REPLAY_SAMPLE_RATE =
  Number(env("NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE")) || 50;
export const DD_TRACK_USER_INTERACTIONS = true;
export const DD_TRACK_VIEWS_MANUALLY = false;

// Contentful
export const CF_GRAPHQL_GATEWAY_URL =
  env("NEXT_PUBLIC_CONTENTFUL_GRAPHQL_GATEWAY_URL") || "";
export const CF_LP_SPACE_ID = env("NEXT_PUBLIC_CONTENTFUL_LP_SPACE_ID") || "";
export const CF_LP_SPACE_ENV = env("NEXT_PUBLIC_CONTENTFUL_LP_SPACE_ENV") || "";
export const CF_LP_ACCESS_TOKEN =
  env("NEXT_PUBLIC_CONTENTFUL_LP_ACCESS_TOKEN") || "";

export const GROVER_BASE_URL =
  env("NEXT_PUBLIC_GROVER_BASE_URL") || "https://www.grover.com";

// Support
export const ZENDESK_WIDGET_ID = env("NEXT_PUBLIC_ZENDESK_WIDGET_ID");
export const ZENDESK_LINE_ID = env("NEXT_PUBLIC_ZENDESK_LINE_ID");
export const ZENDESK_FIELD_ORDER_NUMBER = env(
  "NEXT_PUBLIC_ZENDESK_FIELD_ORDER_NUMBER",
);
